import React from "react";
import { Icon } from "@iconify/react";

const MessageIcon = () => (
  <Icon icon="lucide:message-square" width={18} height={18} />
);

export default MessageIcon;
